import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { SearchParams } from 'src/app/shared/models/searchParams';
import { Document } from 'src/app/shared/models/documents/document';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-client-document',
  templateUrl: './client-document.component.html',
  styleUrls: ['./client-document.component.scss']
})
export class ClientDocumentComponent implements OnInit {
  @ViewChild('uploadDocModal') uploadDocModal;
  modalRef: NgbModalRef;

  documents: Document[] = [];
  document: Document;
  searchParams: SearchParams = new SearchParams();
  clientId: number;

  constructor(private modalService: NgbModal,
    private api: ClientsApiService,
    private spinner: NgxSpinnerService,
    private apiService: ClientsApiService,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {
    this.route.parent.data.subscribe(resolversData => {
      this.clientId = resolversData.client.id;
      this.loadDocuments();
    });
  }

  ngOnInit(): void {
  }

  loadDocuments() {
    this.spinner.show();
    this.apiService.getClientDocuments(this.clientId, this.searchParams).subscribe(
      c => {
        this.spinner.hide();
        this.documents = c.results;
      }
    );
  }
  addNewDocument() {
    const document = new Document();
    this.uploadDocModal.open(document);
  }

  uploadDocument(document: Document) {
    const action = '';
    this.documents.unshift(document);
    this.uploadDocModal.close();
    this.toastr.success('Documents uploaded', 'Success!');
  }

  onSearch(e) {
  }

  print() { }

}
